/**
 * 视频分辨率选择器（按模型 supportedResolutions 渲染）
 */

interface VideoResolutionSelectorProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  creditsMap?: Record<string, number>;
  creditsUnitLabel?: string;
}

const RESOLUTION_LABELS: Record<string, string> = {
  '480p': '标清',
  '720p': '高清',
  '1080p': '全高清',
  '4k': '超高清',
};

export function VideoResolutionSelector({
  value,
  onChange,
  options,
  creditsMap = {},
  creditsUnitLabel = '秒',
}: VideoResolutionSelectorProps) {
  if (options.length === 0) return null;

  return (
    <div>
      <div className="text-sm font-medium text-light-text mb-2">分辨率</div>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const isActive = opt === value;
          const label = RESOLUTION_LABELS[opt] || opt;
          const credits = creditsMap[opt];
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onChange(opt)}
              className={`px-3 py-2 rounded-lg border text-sm font-medium transition-all ${
                isActive
                  ? 'border-accent-blue bg-accent-blue text-white shadow-md'
                  : 'border-light-border bg-white text-light-secondary hover:border-accent-blue hover:text-accent-blue'
              }`}
            >
              <span className="block font-semibold">{opt}</span>
              <span className={`block text-xs mt-0.5 ${isActive ? 'opacity-90' : 'text-light-muted'}`}>
                {label}
              </span>
              {Number.isFinite(credits) && (
                <span className={`block text-[11px] mt-1 ${isActive ? 'text-white/90' : 'text-accent-blue'}`}>
                  {credits} 积分/{creditsUnitLabel}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
